import React, { useEffect, useState } from 'react';
import { LoginContainer, LoginContent, LoginBox } from './style';
import { summary_bg } from '../../constants/images';
import { Input, Form, Row, Col, Spin } from 'antd';
import CustomButton from '../../components/CustomButton';
import { loginAPI, changePasswordAPI } from '../../services/admin';
import { showNotify } from '../../utils/showNotify';
// import PropTypes from 'prop-types'

function LoginPage() {
  let [isLoading, setIsLoading] = useState(false);
  let [isChangePassword, setIsChangePassword] = useState(false);

  async function login(data) {
    setIsLoading(true);
    const res = await loginAPI(data).catch(() => setIsLoading(false));

    if (res) {
      localStorage.setItem('opentrace_token', res.token);
      localStorage.setItem('username', data.email);

      window.location.replace('/');
      setIsLoading(false);
    }
  }

  async function changePassword(data) {
    setIsLoading(true);
    const res = await changePasswordAPI(data).catch(() => setIsLoading(false));

    if (res && res.message === 'PASSWORD_CHANGED') {
      setIsChangePassword(false);
      setIsLoading(false);
      showNotify('success', 'Success', 'New password has been saved!');
    }
  }

  function onFinish(values) {
    if (!isChangePassword) {
      login(values);
    } else {
      changePassword(values);
    }
  }

  useEffect(() => {
    localStorage.removeItem('opentrace_token');
  }, []);

  return (
    <LoginContainer
      style={{
        backgroundImage: `url(${summary_bg})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
      }}
    >
      <div className="overlay" />
      <LoginContent>
        <LoginBox>
          {!isChangePassword ? (
            <>
              <h1 className="login-text">Login</h1>
              <div className="login-form">
                <Form name="basic" onFinish={onFinish}>
                  <Row gutter={[32, 0]}>
                    <Col span={24}>
                      <Form.Item
                        name="email"
                        rules={[
                          { required: true, message: 'Username required!' },
                        ]}
                      >
                        <Input placeholder="Username" size="large" />
                      </Form.Item>
                    </Col>

                    <Col span={24}>
                      <Form.Item
                        name="password"
                        rules={[
                          { required: true, message: 'Password required!' },
                        ]}
                      >
                        <Input.Password placeholder="Password" size="large" />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <div
                        className="label-change-password"
                        onClick={() => {
                          setIsChangePassword(true);
                        }}
                      >
                        Change password
                      </div>
                    </Col>
                    <Col span={24}>
                      <Form.Item>
                        <CustomButton
                          type="primary"
                          size="large"
                          htmlType="submit"
                        >
                          {isLoading ? <Spin /> : 'Login'}
                        </CustomButton>
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              </div>
            </>
          ) : (
            <>
              <h1 className="login-text">Change password</h1>
              <div className="login-form">
                <Form name="basic" onFinish={onFinish}>
                  <Row gutter={[32, 0]}>
                    <Col span={24}>
                      <Form.Item
                        name="email"
                        rules={[
                          { required: true, message: 'Username required!' },
                        ]}
                      >
                        <Input placeholder="Username" size="large" />
                      </Form.Item>
                    </Col>

                    <Col span={24}>
                      <Form.Item
                        name="currentPassword"
                        rules={[
                          { required: true, message: 'Password required!' },
                        ]}
                      >
                        <Input.Password
                          placeholder="Current Password"
                          size="large"
                        />
                      </Form.Item>
                    </Col>

                    <Col span={24}>
                      <Form.Item
                        name="newPassword"
                        rules={[
                          { required: true, message: 'Password required!' },
                        ]}
                      >
                        <Input.Password
                          placeholder="New Password"
                          size="large"
                        />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        name="reNewPassword"
                        rules={[
                          { required: true, message: 'Password required!' },
                          ({ getFieldValue }) => ({
                            validator(rule, value) {
                              if (
                                !value ||
                                getFieldValue('newPassword') === value
                              ) {
                                return Promise.resolve();
                              }
                              return Promise.reject('Passwords do not match!');
                            },
                          }),
                        ]}
                      >
                        <Input.Password
                          placeholder="Re-enter New Password"
                          size="large"
                        />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <div
                        className="label-change-password"
                        onClick={() => {
                          setIsChangePassword(false);
                        }}
                      >
                        Login
                      </div>
                    </Col>
                    <Col span={24}>
                      <Form.Item>
                        <CustomButton
                          type="primary"
                          size="large"
                          htmlType="submit"
                        >
                          {isLoading ? <Spin /> : 'Change password'}
                        </CustomButton>
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              </div>
            </>
          )}
        </LoginBox>
      </LoginContent>
    </LoginContainer>
  );
}

LoginPage.propTypes = {};

export default LoginPage;
